import React from 'react';

//components
import Spinner, { SpinnerSize } from '../Spinner/Spinner';
import { ArrowRight } from 'react-feather';
import HiddenLabel from '../labels/HiddenLabel';

//styling
import '../../../../css/global/TextInputs/TextAndSearchInput.scss';



const TextAndSearchInput = ({inputId, inputPlaceholderText, inputValue, setInputValue, onButtonClick, isLoading, hasHiddenLabel}: {inputId: string, inputPlaceholderText?: string, inputValue?: string, setInputValue: any, onButtonClick: any, isLoading: boolean, hasHiddenLabel?: boolean}) => {

    return (
        <div className='url-input-container'>
            {hasHiddenLabel && <HiddenLabel labelFor={inputId} labelText='Input Value'/>}
            
            <input  className="url-input" 
                    id={inputId}
                    type="text" 
                    placeholder={inputPlaceholderText} 
                    value={inputValue}  
                    onChange={(e) => setInputValue(e.target.value)} 
                    onKeyDown={e => e.key === 'Enter' && inputValue && onButtonClick()} 
            />
            
            <button className="url-input-button" 
                    onClick={onButtonClick} 
                    title='url-input-button' 
                    disabled={!inputValue}> 
                        {isLoading ? <Spinner spinnerSize={SpinnerSize.SMALL}/> : <ArrowRight/>} 
            </button>
        </div>
    )
}
export default TextAndSearchInput;